
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from './integrations/apollo/client';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider as RollbarProvider, ErrorBoundary } from '@rollbar/react';

import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";

import { store, persistor } from './store';
import Router from './routes';
import Error from './pages/Error';
import rollbarConfig from './integrations/rollbar';

// Create a client
const queryClient = new QueryClient();

const App = () => (
  <RollbarProvider config={rollbarConfig}>
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ApolloProvider client={apolloClient}>
          <QueryClientProvider client={queryClient}>
            <React.StrictMode>
            <TooltipProvider>
              {import.meta.env.MODE !== 'production' && (
                <div className="w-full p-2 bg-white/90 text-center text-muted-foreground">
                  current environment: <strong>{ import.meta.env.MODE }</strong> 🚀
                </div>
              )}

              <ErrorBoundary fallbackUI={Error}>
                <Router />
              </ErrorBoundary>
              <Toaster />
              <Sonner />
            </TooltipProvider>
          </React.StrictMode>
        </QueryClientProvider>
      </ApolloProvider>
    </PersistGate>
  </ReduxProvider>
  </RollbarProvider>
);

export default App;
